
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 8.49v6c0 .552.449 1 1 1h5v-7H1zM15 4.49h-3.164c.227-.155.422-.309.558-.447a2.09 2.09 0 000-2.942c-.784-.79-2.15-.788-2.933 0-.434.435-1.584 2.206-1.425 3.39h-.072c.158-1.184-.992-2.955-1.425-3.39-.784-.788-2.15-.788-2.933 0a2.093 2.093 0 00-.001 2.942c.137.138.332.292.559.447H1c-.551 0-1 .45-1 1v1.5a.5.5 0 00.5.5H7v-2h2v2h6.5a.5.5 0 00.5-.5v-1.5c0-.55-.448-1-1-1zm-8.059-.033s-.042.033-.185.033c-.691 0-2.01-.718-2.441-1.152a1.09 1.09 0 010-1.532 1.062 1.062 0 011.515 0c.674.678 1.344 2.41 1.111 2.651zm2.302.033c-.142 0-.184-.032-.184-.033-.233-.24.437-1.973 1.111-2.65a1.09 1.09 0 011.515 0c.42.421.42 1.11 0 1.531-.431.434-1.75 1.152-2.442 1.152zM9 8.49v7h5a1 1 0 001-1v-6H9z","fill":"#000"}})])
          )
        }
      }
    